export const aciDate = {
    iconName: 'date',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M4.2 5.398h15.6s1.2 0 1.2 1.2v13.2s0 1.2-1.2 1.2H4.2s-1.2 0-1.2-1.2v-13.2s0-1.2 1.2-1.2zM3 10.2h18',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.8 7.2V3M16.2 7.2V3M15 13.2L11.4 18 9 15.6',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
